import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../config/authAxios";

const initialState = {
  status: null,
  loading: false,
  data: [],
  error: "",
  message: "",
};

export const getSingleLifelineAction = createAsyncThunk(
  "single-lifeline",
  async (data = null, { rejectWithValue }) => {
    try {
      const res = await axios.get(`/admins/api/get-lifeline/${data?.lifeline_id}`);
      return res?.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getSingleLifelineSlice = createSlice({
  name: "single-lifeline",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSingleLifelineAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSingleLifelineAction.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action?.payload?.data;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
    builder.addCase(getSingleLifelineAction.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
  },
});

export const getSingleLifeLineReducer = getSingleLifelineSlice.reducer;
